import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Breadcrumbs from "./Breadcrumbs";
import { cn } from "../../lib/utils";
import { X } from "lucide-react";

export default function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />

      {/* Mobile drawer */}
      {mobileOpen && (
        <div
          className="lg:hidden fixed inset-0 z-40 bg-black/40"
          onClick={() => setMobileOpen(false)}
        >
          <div
            className="absolute inset-y-0 left-0 w-72 bg-card border-r border-border shadow-pop animate-fade-in"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="h-16 flex items-center justify-between px-4 border-b border-border">
              <span className="font-semibold">Menu</span>
              <button onClick={() => setMobileOpen(false)} className="p-1 rounded hover:bg-muted">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-2">
              {/* Simplified: link to same sidebar routes via <a> */}
              <MobileNav onClose={() => setMobileOpen(false)} />
            </div>
          </div>
        </div>
      )}

      <div className="flex-1 min-w-0 flex flex-col">
        <Navbar onMobileMenu={() => setMobileOpen(true)} />
        <main className={cn("flex-1 p-4 md:p-6 lg:p-8")}>
          <Breadcrumbs />
          <Outlet />
        </main>
        <footer className="border-t border-border py-4 px-6 text-xs text-muted-foreground flex justify-between">
          <span>© {new Date().getFullYear()} CCAMS — Cyber Compliance & Audit Management System</span>
          <span>v1.0.0</span>
        </footer>
      </div>
    </div>
  );
}

function MobileNav({ onClose }) {
  // Re-use links from Sidebar by hardcoding here for simplicity
  const links = [
    { to: "/dashboard", label: "Dashboard" },
    { to: "/audits", label: "Audits" },
    { to: "/risks", label: "Risk Register" },
    { to: "/findings", label: "Findings" },
    { to: "/tasks", label: "My Tasks" },
    { to: "/organizations", label: "Organizations" },
    { to: "/users", label: "Users" },
    { to: "/notifications", label: "Notifications" },
    { to: "/profile", label: "Profile" },
    { to: "/settings", label: "Settings" },
  ];
  return (
    <ul>
      {links.map((l) => (
        <li key={l.to}>
          <a
            href={l.to}
            onClick={onClose}
            className="block px-3 py-2 rounded-md text-sm hover:bg-muted"
          >
            {l.label}
          </a>
        </li>
      ))}
    </ul>
  );
}
